<template>
  <div>
    <spacer :y="4"/>
    <loader-simple :flag="flag.loader">
      <ul v-if="!flag.loader">
        <stack-item v-if="targetUser">
          <contents-box
            title="相談履歴"
            :bg="userBoxColor(targetUser)">

            <div :class="$style.historyCount">
              <p :class="$style.historyCountTotal">実施総数　{{ historyCount.reserve.done + historyCount.text.done }} 回</p>
              <p v-if="onlineVirtualCountLabel">
                <span>{{ onlineVirtualCountLabel }}　</span>
                <span>実施 {{ historyCount.reserve.done }} 回</span>
                <span> / </span>
                <span>当日キャンセル {{ historyCount.reserve.cancelOnTheDay }} 回</span>
                <span> / </span>
                <span>事前キャンセル {{ historyCount.reserve.cancelBefore }} 回</span>
              </p>
              <p v-if="historyCount.text.done > 0">
                <span>テキスト　</span>
                <span>{{ historyCount.text.done }} 回</span>
              </p>
            </div>

            <user-box
              type="inner" :showId="true"
              :user="targetUser"
              :showCocomoniBtn="true"
              :ownUser="user">
            </user-box>
            <spacer :y="3" />
            <histories
              :histories="histories"
              :showNew="false"
              :hideCounseling="true"
              :riskApplications="riskApplications"
              :isCompany="isCompany"
            />
          </contents-box>
        </stack-item>
      </ul>
    </loader-simple>
    <spacer :y="4"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Histories from '@/views/components/Histories.vue';
import ContentsBox from '@/views/components/ContentsBox.vue';
import UserBox from '@/views/components/UserBox.vue';
import StackItem from '@/views/components/StackItem.vue';
import LoaderSimple from '@/views/components/LoaderSimple.vue';
import Spacer from '@/views/components/Spacer.vue';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'history',
  mixins: [cf],
  components: {
    Histories,
    ContentsBox,
    UserBox,
    StackItem,
    LoaderSimple,
    Spacer,
  },
  data() {
    return {
      flag: {
        loader: true,
      },
      customerName: null,
      slug: null,
      reserve: null,
      reserves: [],
      texts: [],
      histories: [],
      memo: null,
      targetUser: null,
      riskApplications: [], // 承認された申請のみ
    };
  },
  async created() {
    const slug = cf.convert2Num(this.$route.params.slug);
    this.slug = slug;

    // 画面表示前に取得しておきたいのでawaitで実行する
    await this.getRiskApplications();

    this.getReserves();
    this.getUser();
  },
  computed: {
    ...mapState(['user', 'helper']),
    isCompany() { // 閲覧中の管理者自身の所属組織が企業契約か（履歴タブと同じ判定軸でコメント欄タイトルを出し分ける）
      return Boolean(this.user?.school?.[0]?.is_company);
    },
    reserveHistories() {
      return this.histories.filter((h) => (h.type === 'reserve' || h.type === 'virtualReserve')); // オンライン/バーチャル相談履歴のみ
    },
    textHistories() {
      return this.histories.filter((h) => h.type === 'text' && h.content.flag === 11); // テキスト相談履歴のみ（実施済み）
    },
    historyCount() {
      return {
        reserve: {
          done: this.reserveHistories.filter((h) => [11].includes(h.content.flag)).length, // 実施済み
          cancelOnTheDay: this.reserveHistories.filter((h) => [902].includes(h.content.flag)).length, // 当日キャンセル
          cancelBefore: this.reserveHistories.filter((h) => [901, 903].includes(h.content.flag)).length, // 事前キャンセル
        },
        text: {
          done: this.textHistories.length,
        },
      };
    },
    onlineVirtualCountLabel() {
      const hasOnline = this.reserveHistories.some((h) => h.content._counselingType.counseling_type === 1);
      const hasVirtual = this.reserveHistories.some((h) => h.content._counselingType.counseling_type === 3);
      if (hasOnline && hasVirtual) return 'オンライン・バーチャル';
      if (hasOnline) return 'オンライン';
      if (hasVirtual) return 'バーチャル';
      return '';
    },
  },
  methods: {
    getUser() {
      const params = {
        id: this.slug,
        isRisk: 1,
        includeDeleted: 1,
      };
      this.axios({
        method: 'get',
        url: '/v1/user/get/detail',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.targetUser = res.data;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
    getReserves() {
      const params = {
        from_user_id: this.slug,
        sort: true,
        counseling_type: -1, // 全ての相談種別
      };
      this.axios({
        method: 'get',
        url: '/v1/reserve/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.reserves = res.reserves.data;
          if (this.reserves.future.length) this.username = this.reserves.future[0].fromUser.username;
          else if (this.reserves.history.length) this.username = this.reserves.history[0].fromUser.username;
          this.getTexts();
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
    getTexts() {
      const params = {
        user_id: this.slug,
        sort: true,
      };
      this.axios({
        method: 'GET',
        url: '/v1/messagegroup/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.texts = res.groups.data;
          this.sortHistories();
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
    sortHistories() {
      this.histories = [];
      const now = this.formatTimestamp(new Date(), 'YYYY-MM-DD HH:mm:ss');
      const reserveKeys = Object.keys(this.reserves);
      reserveKeys.forEach((key) => {
        this.reserves[key].forEach((row) => {
          const schedule = this.formatTimestamp(row.schedule.date, 'YYYY-MM-DD HH:mm:ss');
          if (schedule < now || (schedule > now && row.flag > 900)) {
            // 事前キャンセルもリストへ含める
            this.histories.push({
              date: schedule,
              type: row._counselingType.counseling_type === 3 ? 'virtualReserve' : 'reserve',
              content: row,
            });
          }
        });
      });
      this.texts.answered.forEach((row) => {
        this.histories.push({
          date: row.messages[1].updated_at,
          type: 'text',
          content: row,
        });
      });
      this.histories.sort((a, b) => {
        if (a.date > b.date) return -1;
        return 1;
      });
      this.flag.loader = false;
    },
    updateMemo(e) {
      this.memo = e.target.value;
    },
    registMemo() {
      const data = {
        reserve_id: this.reserve.id,
        memo: this.memo,
        user_id: this.user.id,
      };

      if (this.reserve.memos.counselor[0]) data.id = this.reserve.memos.counselor[0].id;
      else data.id = null;

      const endpoint = data.id ? 'updater' : 'register';

      this.axios({
        method: 'POST',
        url: `/v1/reserve/memo/set/${endpoint}`,
        data,
      })
        .then(() => {
          alert('カルテを保存しました。');
          this.getReserves();
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },
    async getRiskApplications() {
      const STATUS_APPROVED = 100; // 承認
      try {
        const response = await this.axios({
          method: 'GET',
          url: '/v1/riskApplications/get/list',
          params: {
            statuses: [STATUS_APPROVED],
            target_user_id: this.slug,
          },
        });
        this.riskApplications = response.data.data;
      } catch (e) {
        alert('リスク報告書情報の取得に失敗しました');
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" module>
.date {
  font-weight: bold;
}
.detail {
  li {
    font-size: 14px;
    display: flex;
    align-items: flex-start;
    .content {
      font-size: 14px;
      margin-top: 3px;
      flex: 1;
    }
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    > p {
      flex: 1;
    }
  }
}
.label {
  width: 100px;
  margin-right: 20px;
}
.who5 {
  flex: 1;
  li {
    justify-content: space-between;
  }
}
.types {
  margin-right: 8px;
  &:not(:first-child) {
    &:before {
      content: "/";
    }
  }
}
.textarea {
  width: 100%;
  border-radius: 8px;
  background-color: var(--gray-sub);
  border: none;
  appearance: none;
  padding: 12px;
  outline: none;
}
.assistant {
  font-size: 12px;
  color: var(--pink);
}
.historyCount {
  font-size: 16px;
  margin-bottom: 12px;
  margin-left: 1rem;
  font-weight: bold;
  .historyCountTotal {
    font-size: 18px;
    margin-bottom: 5px;
  }
}
</style>
